import { useCallback } from 'react'
import { buildInvestigationBundle } from './buildInvestigationBundle'

export function useExplainRowHandler ({
  trayRef,
  setOpen,
  clientId,
  config,
  activeViewName,
  asOfDate,
  orionRequest
}) {
  return useCallback((row) => {
    if (!row?.original || !orionRequest) return
    const rowPath = collectRowPath(row)
    const { bundle, subject } = buildInvestigationBundle({
      clientId,
      config,
      viewName: activeViewName || config?.name,
      asOfDate,
      row: row.original,
      rowPath,
      orionRequest
    })
    setOpen(true)
    trayRef.current?.startInvestigation(bundle, subject)
  }, [trayRef, setOpen, clientId, config, activeViewName, asOfDate, orionRequest])
}

function collectRowPath (row) {
  const path = []
  let current = row
  while (current) {
    const name = current.original?.name
    if (name) path.unshift(name)
    current = typeof current.getParentRow === 'function' ? current.getParentRow() : null
  }
  return path
}
